import store from '@/store';
import router from '@/router';
import {IAuthData} from "@/model/IAuthData";
import {initMicroFronts, redirectToFirstMenu} from "@/services/micro-front-service";
import {ISubscriptionData} from "@/model/ISubscriptionData";
import {subscribeToNotification} from "@/services/notification-service";
import {connect, reconnect, subscribeToStomp, unsubscribeAll} from "@/services/stomp-service";
import { Fetch } from 'water-rest/src/fetch/Fetch';
import {IMenuBaseEntity} from "@/model/menu/IMenuBaseEntity";
import {IMenuRouteInfo} from "@/model/menu/IMenuRouteInfo";
import {IMenuSubEntity} from "@/model/menu/IMenuSubEntity";
import {initMap} from "@/services/map-service";
import {ModuleSystem} from "water-rest/src/model/GlobalTypes";

export const ignoreRoutes = ['/login', '/no-access', '/download-app'];

export const setRouterEvents = () => {
    router.afterEach((to, from) => {
        let authData: IAuthData | undefined = undefined;
        const rawData = localStorage.getItem( 'authData' );

        if ( rawData )
            authData = JSON.parse( rawData );

        if ( !ignoreRoutes.includes( to.fullPath ) ) {
            if ( !authData ) {
                if ( to.fullPath !== '/' ) localStorage.setItem('redirectTo', router.currentRoute.fullPath);
                router.push('/login');
            }
            else if ( to.fullPath === '/' )
                redirectToFirstMenu( store.getters.menu );
        }
        else {
            if ( authData ) {
                const isServicesLoaded = store.state.isServicesLoaded;

                if ( !isServicesLoaded ) {
                    store.commit('setServicesLoadStart');
                    initMicroFronts(authData, true);
                }
                else
                    redirectToFirstMenu( store.getters.menu );
            }
        }
    });
};

export const subscribeToWebPush = (authData: IAuthData) => {
    const subscriptionData: PushSubscription = store.getters.subscriptionData;
    if ( !subscriptionData || !authData ) return;

    Fetch.post<ISubscriptionData>(`${Fetch.buildMessagingModuleUrl()}/subscriptions/subscribe`,
        JSON.stringify({
            ...subscriptionData.toJSON(),
            expirationTime: new Date().getTime() + authData.expiresAt
        }),
        {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        })
        .then((response) => {
            localStorage.setItem('clientUuid', response.uuid);
        })
        .catch((error) => {
            console.error(error);
        });
};

export const resubscribeToWebPush = (authData: IAuthData) => {
    const clientUuid: string | null = localStorage.getItem('clientUuid');

    if ( !clientUuid ) {
        subscribeToWebPush(authData);
        return;
    }

    const subscriptionData: PushSubscription = store.getters.subscriptionData;
    if ( !subscriptionData || !authData ) return;

    Fetch.post<ISubscriptionData>(`${Fetch.buildMessagingModuleUrl()}/subscriptions/resubscribe`,
        JSON.stringify({
            ...subscriptionData.toJSON(),
            expirationTime: new Date().getTime() + authData.expiresAt,
            uuid: clientUuid
        }),
        {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        })
        .then((response) => {
            localStorage.setItem('clientUuid', response.uuid);
        })
        .catch((error) => {
            console.error(error);
        });
};

export const unsubscribe = (username: string): Promise<any> => {
    const params = new URLSearchParams();
    params.append('username', username);
    const clientUuid: string | null = localStorage.getItem('clientUuid');
    if ( clientUuid )
        params.append('clientUuid', clientUuid);
    return Fetch.post<any>(`${Fetch.buildMessagingModuleUrl()}/subscriptions/unsubscribe`, params);
};

const refreshTokenFromSocket = (response: IAuthData) => {
    console.log("GOT NEW TOKEN!", response);
    store.commit('setAuthDataInit', response);
    reconnect(response);
};

export const subscribeToTokenUpdate = (authData: IAuthData): void => {
    subscribeToStomp({
        subscriptionName: 'token',
        topicName: `/topic/tokens/${authData.sub}`,
        callback: refreshTokenFromSocket
    });
};

export const isAndroid = (): boolean => {
    // @ts-ignore
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(userAgent);
}

export const bindUser = (authData: IAuthData): void => {
    if ( isAndroid() ) {
        console.warn('ANDROID: BIND USER');
        const headers = new Headers({
            'Content-Type': 'application/json',
            'cache-control': 'no-cache'
        });
        const init = {
            method: 'POST',
            headers,
            body: JSON.stringify({ userId: authData.sub })
        };

        fetch('http://127.0.0.1:8080/bindUser', init);
    }
};

export const unbindUser = (authData: IAuthData): void => {
    if ( isAndroid() ) {
        console.warn('ANDROID: UNBIND USER');
        const headers = new Headers({
            'Content-Type': 'application/json',
            'cache-control': 'no-cache'
        });
        const init = {
            method: 'POST',
            headers,
            body: JSON.stringify({ userId: authData.sub })
        };

        fetch('http://127.0.0.1:8080/unbindUser', init);
    }
};

export const login = (username: string, password: string): Promise<any> => {
    const params = {
        username,
        password
    }

    return new Promise<any>((resolve, reject) => {

        Fetch.post<IAuthData>(`${Fetch.buildAuthModuleUrl()}/oauth/login`, JSON.stringify(params),  { 'Content-Type': 'application/json' })
            .then( (response) => {
                const authData = response;

                // if ( authData.groups.find( ( group ) => group.name === 'DW_ROLE' ) ) {
                    store.commit('setAuthDataInit', response);

                    let redirectTo = localStorage.getItem('redirectTo');
                    if ( redirectTo === '/' ) {
                        redirectTo = null;
                        localStorage.removeItem('redirectTo');
                        router.push('/');
                    }
                    else if ( redirectTo ) {
                        router.push(redirectTo);
                        localStorage.removeItem('redirectTo');
                    }
                    else
                        router.push('/');

                    store.commit('setServicesLoadStart');
                    subscribeToWebPush(authData);
                    initMap();
                    initMicroFronts(authData, !redirectTo);
                    connect(authData);
                    subscribeToNotification(authData);
                    subscribeToTokenUpdate(authData);
                    bindUser(authData);
                    resolve(null);
                // }
                // else {
                //     router.push("/no-access");
                //     resolve();
                // }

            } )
            .catch( (error) => {
                reject(error);
            } );
    });
};

const sendLogoutRequest = (accessToken: string) => {
    const params = new URLSearchParams();
    params.append('token', accessToken);
    Fetch.post(`${Fetch.buildAuthModuleUrl()}/oauth/revoke`, params)
        .then( (response) => {
            store.commit('removeAuthData');
            router.push('/login');
            location.reload();
        } )
        .catch( (error) => {
            store.commit('removeAuthData');
            router.push('/login');
            location.reload();
        } );
};

export const logout = (): void => {
    const authData: IAuthData = store.getters.authData;
    unsubscribeAll();
    if (authData) unbindUser(authData);

    if ( !authData ) {
        store.commit('removeAuthData');
        router.push('/login');
        location.reload();
        return;
    }

    const { sub, accessToken } = authData;
    unsubscribe(sub)
        .then( () => {
            sendLogoutRequest(accessToken);
        } )
        .catch( () => {
            sendLogoutRequest(accessToken)
        } )
};

export const clearAuthState = (): void => {
    store.commit('removeAuthData');
    router.push('/login');
    location.reload();
};

export const refreshToken = (authData: IAuthData) => {
    const isTokenRefreshing: boolean = store.getters.isTokenRefreshing;
    console.log(isTokenRefreshing, authData);
    if ( isTokenRefreshing ) return;

    store.commit('setTokenRefreshing', true);
    const params = new URLSearchParams();
    params.append('token', authData.accessToken);
    Fetch.post<IAuthData>(`${Fetch.buildAuthModuleUrl()}/oauth/refresh`, params)
        .then( (response) => {
            store.commit('setAuthDataInit', response);
            resubscribeToWebPush(response);
            subscribeToNotification(response);
            subscribeToTokenUpdate(response);
            bindUser(response);
            store.commit('setTokenRefreshing', false);
        } )
        .catch( (error) => {
            console.warn('CATCH ERROR ON REFRESH', error);
            store.commit('setTokenRefreshing', false);
            logout();
        } );
};

export const getToken = (authData: IAuthData): Promise<IAuthData> => {
    if ( !authData.accessToken ) {
        logout();
        return Promise.reject();
    }
    if ( navigator.onLine )
        return Fetch.get<IAuthData>(`${Fetch.buildAuthModuleUrl()}/oauth/token?token=${authData.accessToken}`);
    return Promise.resolve(authData);
};

export const startTimer = (authData: IAuthData) => {
    let { expiresAt } = authData;

    if ( expiresAt > 10000 )
        expiresAt = expiresAt - 10000;

    console.log('SET TIMEOUT:', expiresAt);
    setTimeout( () => {
        refreshToken(authData);
    }, expiresAt );
};

export const isMenuAvailable = (menu: IMenuRouteInfo, authData: IAuthData | undefined): boolean => {
    if ( !authData ) return false;

    let isGroupPresent = true;
    let isRolePresent = true;
    let isSystemPresent = true;

    if ( menu.groups && menu.groups.length > 0 ) {
        for ( let i = 0; i < menu.groups.length; i++ ) {
            const group = menu.groups[i];
            if ( !authData.groups.find( eachGroup => eachGroup.name === group ) ) {
                isGroupPresent = false;
                break;
            }
        }
    }

    if ( menu.roles && menu.roles.length > 0 ) {
        let foundRoles = 0;
        for ( let i = 0; i < menu.roles.length; i++ ) {
            const role = menu.roles[i];
            foundRoles += authData.groups.filter( eachGroup => eachGroup.roles && eachGroup.roles.includes(role)).length;
        }
        if (foundRoles === 0) {
            isRolePresent = false;
        }
    }

    if ( menu.systems && menu.systems.length > 0 ) {
        let foundSystems = 0;
        for ( let i = 0; i < menu.systems.length; i++ ) {
            const system = menu.systems[i];
            foundSystems += store.getters.systems.filter( (eachSystem: ModuleSystem) => eachSystem === system ).length;
        }
        if (foundSystems === 0) {
            isSystemPresent = false;
        }
    }
    return isGroupPresent && isRolePresent && isSystemPresent;
};

export const prepareSubMenus = (menu: IMenuBaseEntity, authData: IAuthData | undefined) => {
    if ( menu.subMenus && menu.subMenus.length > 0 ) {
        menu.subMenus = menu.subMenus.filter( (subMenu) => {
            if ( isMenuAvailable( subMenu, authData ) ) {
                prepareSubMenus(subMenu, authData);
                return true;
            }
            return false;
        } );
        menu.subMenus.sort( (a, b) => {
            if (a.sortOrder < b.sortOrder) return -1;
            if (a.sortOrder > b.sortOrder) return 1;
            return 0;
        } );
    }
}
